exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div[class^=ngafx-]{display:none}div[class^=ngafx-].start{display:inherit}div[class^=ngafx-].infinite{animation-iteration-count:infinite}div[class^=ngafx-].medium{animation-duration:.75s}div[class^=ngafx-].slow{animation-duration:1.25s}div[class^=ngafx-].fast{animation-duration:.45s}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/angular-animation-fx/sources/styles/ngafx.css
 ** module id = 661
 ** module chunks = 1
 **/